import React, { Component } from 'react';

class TW extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            isLoading: false
        };
    }


componentDidMount() {
    fetch('https://hnq0ok7jgc.execute-api.us-east-2.amazonaws.com/prod')
        .then((response) => response.json())
        .then((responseJson) => {
            this.setState({data : responseJson});
        })
        .catch((error) => {
            console.error(error);
        });
}

render() {
    const { data } = this.state;
    return (
        <div>
            <ul>
                {data.map(d =>
                <li key={d.timestamp}>
                    <a href={d.url}>{d.title}</a>
                </li>
                )}
            </ul>
        </div>
    )
}

}
export default TW;


// WEBPACK FOOTER //
// ./src/components/TW.js